/**
 * Constants for student email validation error types
 */
export const StudentEmailError = {
  INVALID_EMAIL: "invalid-email",
  NOT_STUDENT_EMAIL: "not-student-email",
} as const;

export type StudentEmailErrorType =
  (typeof StudentEmailError)[keyof typeof StudentEmailError];
